<template>
  <editor 
    v-model="content"
    @onChange="onChange"
    @onBlur="onBlur"
    :init="initEditor"
    :plugins="[
      'advlist autolink lists link image charmap print preview anchor textcolor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table contextmenu paste code help'
    ]"
    toolbar="insert | undo redo | formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code preview fullscreen"
  ></editor>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

export default {
  name: 'BKEditor',
  components: {
    Editor
  },
  data() {
    return {
      content: '',
      initEditor: {
        menubar: false,
        branding: false,
        language: 'zh_CN',
        images_upload_handler: (blobInfo, success, failure) => {
          this.$axios
            .post({
              url: '/admin/common/upload',
              dataType: 'file',
              data: blobInfo.blob()
            })
            .then(({ data }) => {
              success(data);
            })
            .catch(() => {
              failure('上传错误！');
            });
        }
      }
    };
  },
  props: ['value'],
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.content = newVal || '';
      }
    }
  },
  methods: {
    onChange(evt) {
      const editor = evt.target;
      const content = editor.getContent();

      this.$emit('input', content);
      this.$emit('change', content);
      this.$parent.$emit('el.form.change', content);
    },
    onBlur(evt) {
      const editor = evt.target;
      const content = editor.getContent();

      this.$emit('input', content);
      this.$emit('change', content);
      this.$parent.$emit('el.form.blur', content);
    }
  },
  mounted() {
    this.content = this.value;
  }
};
</script>
